import { env } from "@x1-utils/env";

import { x1ErrorLite } from "./x1ErrorLite";

export function invariant(condition, message, ...params) {
  if (!condition) {
    let errorMessage = message;

    if (typeof errorMessage === "number") {
      const { message: decodedMessage, decoderLink } = decodeInvariantMessage(
        errorMessage,
        params,
      );
      errorMessage = decodedMessage;
      params.unshift(decoderLink);
    } else if (errorMessage === undefined) {
      errorMessage = "Invariant: ";

      for (let i = 0; i < params.length; i++) {
        errorMessage += "%s,";
      }
    }

    const error = new Error(errorMessage);
    error.name = "Invariant Violation";
    error.messageFormat = errorMessage;
    error.messageParams = params.map((param) => String(param));
    error.taalOpcodes = [x1ErrorLite.TAALOpcode.PREVIOUS_FRAME];

    throw error;
  }
}

function decodeInvariantMessage(code, params) {
  let message = "Minified invariant #" + code + "; %s";

  if (params.length > 0) {
    message += " Params: " + params.map(() => "%s").join(", ");
  }

  const decoderLink =
    env.show_invariant_decoder === true
      ? "visit " +
        generateDecoderLink(code, params) +
        " to see the full message."
      : "";

  return {
    message,
    decoderLink,
  };
}

function generateDecoderLink(code, params) {
  let link = "https://www.alexisdelacruz.dev/intern/invariant/" + code + "/";

  if (params.length > 0) {
    link +=
      "?" +
      params
        .map(
          (param, index) =>
            "args[" + index + "]=" + encodeURIComponent(String(param)),
        )
        .join("&");
  }

  return link;
}
